import TreeChunk, { UnsupportedTreeFormatError, SUPPORTED_FORMAT_VERSION } from './TreeChunk';
import createTreeViewFactory from './TreeViewFactory';

export default class TreeStore {
    constructor() {
        this.chunks = [];
        this.missingCustomFieldIds = [];
    }

    addChunk(buffer) {
        const chunk = new TreeChunk(buffer);

        if (this.chunks.length > 0) {
            const reference = this.chunks[0].chunk.columnNames;
            const current = chunk.columnNames;
            if (reference.length !== current.length || reference.some((name, index) => name !== current[index]))
                throw new UnsupportedTreeFormatError(
                    'Deux blocs du même projet ne décrivent pas les mêmes colonnes. '
                    + "Le schéma des champs personnalisés doit être calculé à l'échelle du projet côté API."
                );
        }

        const entry = { chunk, createView: createTreeViewFactory(chunk) };
        this.chunks.push(entry);

        for (const id of chunk.missingCustomFieldIds)
            if (!this.missingCustomFieldIds.includes(id)) this.missingCustomFieldIds.push(id);

        return entry;
    }

    get rowCount() {
        return this.chunks.reduce((total, { chunk }) => total + chunk.rowCount, 0);
    }

    get byteLength() {
        return this.chunks.reduce((total, { chunk }) => total + chunk.byteLength, 0);
    }

    clear() {
        this.chunks = [];
        this.missingCustomFieldIds = [];
    }

    describe() {
        const rowCount = this.rowCount;
        return {
            version: SUPPORTED_FORMAT_VERSION,
            chunks: this.chunks.length,
            trees: rowCount,
            megabytes: Math.round((this.byteLength / 1048576) * 10) / 10,
            bytesPerTree: rowCount > 0 ? Math.round(this.byteLength / rowCount) : 0,
            heaviestColumns: this.chunks.length > 0 ? this.chunks[0].chunk.columnSizes().slice(0, 10) : []
        };
    }
}

export function toFeature(view) {
    if (!view) return view;
    return { ...view, properties: { ...view.properties } };
}

// Un seul projet ouvert à la fois ; ProjectMap le vide à l'ouverture d'un projet.
export const treeStore = new TreeStore();

if (typeof window !== 'undefined') {
    window.__gralityTreeStore = treeStore;
    window.__gralityToFeature = toFeature;
}

export { UnsupportedTreeFormatError };
